import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11.63,
	height: 12,
	viewBox: "0 0 11.63 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M9.63,10.41c-.1,0-.2-.03-.29-.08l-.77-.44c-.25,.18-.52,.34-.8,.46v.89c0,.26-.18,.49-.43,.56-.51,.13-1.03,.2-1.55,.2s-1.02-.07-1.53-.22c-.25-.07-.43-.3-.43-.56v-.89c-.28-.13-.55-.28-.8-.46l-.77,.44c-.09,.05-.19,.08-.29,.08C1.16,10.39,0,7.88,0,7.39c0-.18,.11-.38,.29-.48l.77-.44c-.02-.15-.02-.31-.02-.46s0-.31,.02-.46l-.77-.44c-.18-.11-.29-.3-.29-.5C0,3.97,1.22,1.59,1.98,1.59c.1,0,.2,.03,.29,.08l.77,.44c.25-.18,.52-.34,.8-.46V.76c0-.26,.18-.49,.43-.56,.51-.13,1.03-.2,1.55-.2s1.04,.07,1.55,.2c.25,.07,.43,.3,.43,.56v.89c.28,.13,.55,.28,.8,.46l.77-.44c.09-.05,.19-.08,.29-.08,.83,0,1.98,2.51,1.98,3,0,.2-.11,.39-.29,.5l-.77,.44c.02,.15,.02,.31,.02,.46s0,.31-.02,.44l.77,.44c.18,.11,.29,.3,.29,.5,0,.64-1.22,3.03-2,3.02Zm.77-2.75l-1.02-.59c.06-.6,.09-.84,.09-1.07s-.03-.47-.09-1.07l1.02-.59c-.2-.54-.48-1.04-.85-1.48l-1.02,.59c-.98-.71-.75-.58-1.86-1.08V1.2c-.2-.03-.49-.07-.85-.07-.25,0-.54,.02-.85,.07v1.18c-1.1,.5-.87,.36-1.86,1.08l-1.02-.59c-.37,.44-.66,.94-.85,1.48l1.02,.59c-.06,.6-.09,.84-.09,1.07s.03,.47,.07,1.07l-1,.57c.2,.54,.48,1.04,.85,1.48l1.02-.59c.98,.71,.76,.58,1.86,1.08v1.18c.2,.03,.49,.07,.85,.07,.25,0,.54-.02,.85-.07v-1.18c1.1-.5,.87-.36,1.86-1.08l1.02,.59c.37-.42,.66-.92,.85-1.46Zm-2.33-1.68c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25Zm-1.12,.02c0-.62-.5-1.12-1.12-1.12s-1.12,.5-1.12,1.12,.5,1.12,1.12,1.12,1.12-.5,1.12-1.12Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgSettings);
export default ForwardRef;
